<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="活动id" prop="activityId">
              <el-input
                v-model="searchForm.activityId"
                clearable
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动名称" prop="activityName">
              <el-input
                v-model="searchForm.activityName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="顾客名称" prop="userName">
              <el-input
                v-model="searchForm.userName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="参与时间">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="activityId" label="活动id" align="center" width="100" ></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="contactsName" label="顾客名称" align="center" width="130" ></el-table-column>
          <el-table-column prop="createdTime" label="拼团时间" align="center" width="160"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称"  align="center" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="storeName" label="分享门店" align="center" width="150"></el-table-column>
          <el-table-column prop="h5UserName" label="分享职员" align="center" width="140"></el-table-column>
          <el-table-column prop="teamStatusExcel" label="拼团状态" align="center"  width="120"></el-table-column>
          <el-table-column prop="goodsPrice" label="实付价格(元)" align="center" width="160"></el-table-column>
          <el-table-column prop="statusExcel" label="状态" align="center" width="160"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import moment from 'moment';
export default {
  name: "groupData",
  mixins: [tableMixin],
  data() {
    return {
      searchForm: {
        activityId:'',
        activityName:'',
        userName: "",
        startTime: "",
        endTime: "",
      },
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.ActivityManagement
        .getGroupBuyingOrderList(params) 
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportList() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("getGroupBuyingOrderList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}

</style>
